import moment from 'moment'
import { HolidayHourWithTimePeriods } from './HolidayHours'
import { convertUTCToPartnerTimezone } from 'utils'
import { AvailabilityList, AvailabilityRow, AvailableDay, AvailableTimeContainer, AvailableTime } from './../styles'

type Props = {
  holidayHours: HolidayHourWithTimePeriods[]
  partnerTimezone: string
}

const HolidayHoursList = ({ holidayHours, partnerTimezone }: Props) => {
  const today = new Date().toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase()
  
  const transformedHours = holidayHours.map((hour) => {
    const dateInPartnerTZ = convertUTCToPartnerTimezone(hour.attributes.date, partnerTimezone)
    const momentDate = moment(dateInPartnerTZ)
    const formattedDate = momentDate.format('MMM D, YYYY')
    const isToday = momentDate.format('YYYY-MM-DD') === today
    
    return {
      id: hour.id,
      date: formattedDate,
      isToday,
      hours: hour.attributes.closed
        ? 'Closed'
        : `${moment(hour.time_period?.start_time, 'HH:mm').format('h:mm A')} - ${moment(hour.time_period?.end_time, 'HH:mm').format('h:mm A')}`,
    }
  })

  return (
    <AvailabilityList>
      {transformedHours.map(({ id, date, hours, isToday }) => (
        <AvailabilityRow key={id}>
          <AvailableDay isHighlighted={isToday}>{date}</AvailableDay>
          <AvailableTimeContainer>
            {hours.split(',').map((hour, index) => (
              <AvailableTime key={index} isHighlighted={isToday}>
                {hour}
              </AvailableTime>
            ))}
          </AvailableTimeContainer>
        </AvailabilityRow>
      ))}
    </AvailabilityList>
  )
}

export default HolidayHoursList
